import { Button, Grid2, Typography } from '@mui/material';
import { Field, FieldArray, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { AutoCompleteField } from '../../../../shared/components/formfields/AutoCompleteField';
import { Grid_Gap, Grid_Gap_LG, Input_Width, Input_Width_LG } from '../../../../shared/constants';
import { TextFormField } from '../../../../shared/components/formfields/TextFormField';
import { DateFormField } from '../../../../shared/components/formfields/DataFormField';
import CustomDivider from '../../../../shared/utils/CustomDivider';
import CustomSlider from './../../../../shared/components/formfields/CustomSlider'
import { DropzoneUploadFormField } from '../../../../shared/components/formfields/DropzoneUploadFormField';
import TabsComponent from '../../../../shared/components/Tabs/TabComponent';
import TabPanel from '../../../../shared/components/Tabs/TabPanel';
import useTabs from '../../../../shared/hook/useTabs';
import SprintWrapper from '../../../../shared/components/admin/SprintWrapper';
import AddIcon from '@mui/icons-material/Add';
import { IdAutoCompleteField } from '../../../../shared/components/formfields/IdAutoCompleteField';
import { TimeFormField } from '../../../../shared/components/formfields/TimeFormFields';
import { useToaster } from '../../../../shared/utils/ToasterProvider';
import { useMutation } from '@tanstack/react-query';
import useAuthStore from '../../../../store/useAuthStore';
import { nodeApi } from '../../../../assets/api/useStudentPostApi';




const RenderPackages = ({ prefix, values }) => {
    const Days = [
        { id: 1, value: "Monday", label: "Mon" },
        { id: 2, value: "Tuesday", label: "Tue" },
        { id: 3, value: "Wednesday", label: "Wed" },
        { id: 4, value: "Thursday", label: "Thu" },
        { id: 5, value: "Friday", label: "Fri" },
        { id: 6, value: "Saturday", label: "Sat" },
        { id: 7, value: "Sunday", label: "Sun" },
    ];

    return (
        < Grid2 container size={12} spacing={Grid_Gap_LG}>
            {/* BASIC INFO */}
            <Grid2 container spacing={Grid_Gap_LG} size={12}>
                <Grid2 size={Input_Width_LG}>
                    <Field
                        name={`${prefix}.name`}
                        component={TextFormField}
                        label="Package Name"
                    />
                </Grid2>
                <Grid2 size={Input_Width_LG}>
                    <Field
                        name={`${prefix}.start_date`}
                        component={DateFormField}
                        label="Start Date"
                    />
                </Grid2>
                <Grid2 size={Input_Width_LG}>
                    <Field
                        name={`${prefix}.end_date`}
                        component={DateFormField}
                        label="End Date"
                    />
                </Grid2>
                <Grid2 size={Input_Width_LG}>
                    <Field
                        name={`${prefix}.reduction_price`}
                        component={TextFormField}
                        label="Reduction"
                    />
                </Grid2>
            </Grid2>
            <CustomDivider size={"1rem"} />
            {/* LEVELS */}
            <Grid2 size={12}>
                <FieldArray name={`${prefix}.levels`}>
                    {({ push, remove }) => (
                        <>
                            {(values?.[prefix]?.levels ?? []).map((lvl, lIndex) => (
                                <SprintWrapper
                                    key={lIndex}
                                    headerText={`Level ${lIndex + 1}`}
                                    onDelete={() => remove(lIndex)}
                                >
                                    <Grid2 container spacing={Grid_Gap_LG}>
                                        <Grid2 size={Input_Width}>
                                            <Field
                                                name={`${prefix}.levels[${lIndex}].name`}
                                                component={TextFormField}
                                                label="Name"
                                            />
                                        </Grid2>
                                        <Grid2 size={Input_Width}>
                                            <Field
                                                name={`${prefix}.levels[${lIndex}].description`}
                                                component={TextFormField}
                                                label="Description"

                                            />
                                        </Grid2>
                                        <Grid2 size={Input_Width}>
                                            <Field
                                                name={`${prefix}.levels[${lIndex}].price`}
                                                component={TextFormField}
                                                label="Price"
                                            />
                                        </Grid2>
                                    </Grid2>
                                </SprintWrapper>
                            ))}

                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap_LG}>
                                <Grid2 size={Input_Width}>
                                    <Button
                                        startIcon={<AddIcon />}
                                        onClick={() => push({ name: '', description: '', price: '' })}
                                        variant="outlined"
                                        fullWidth

                                    >
                                        Add More Level
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </>
                    )}
                </FieldArray>
            </Grid2>
            <CustomDivider size={"1rem"} />

            {/* IMAGE + SLOTS */}
            <Grid2 size={12}>
                <Field
                    name={`${prefix}.image`}
                    component={DropzoneUploadFormField}
                    label="Image"
                />
            </Grid2>
            <Grid2 size={Input_Width_LG}>
                <Field
                    name={`${prefix}.max_slots`}
                    component={TextFormField}
                    label="Max Slots"
                    type="number"
                />
            </Grid2>

            {/* SESSIONS */}
            <Grid2 size={12}>
                <FieldArray name={`${prefix}.sessions`}>
                    {({ push: pushSession, remove: removeSession }) => (
                        <>
                            {(values?.[prefix]?.sessions ?? []).map((session, sIndex) => (
                                <SprintWrapper
                                    key={sIndex}
                                    headerText={`Session ${sIndex + 1}`}
                                    onDelete={() => removeSession(sIndex)}
                                >
                                    <Grid2 container spacing={Grid_Gap_LG} size={12}>
                                        <Grid2 size={12}>
                                            <Field
                                                name={`${prefix}.sessions[${sIndex}].day`}
                                                component={AutoCompleteField}
                                                options={Days}
                                                label="Day"
                                            />
                                        </Grid2>

                                        {/* SLOT TIMES */}
                                        <Grid2 size={12}>
                                            <FieldArray name={`${prefix}.sessions[${sIndex}].slottime`}>
                                                {({ push: pushSlot, remove: removeSlot }) => (
                                                    <>
                                                        {(session?.slottime ?? []).map((slot, slotIndex) => (
                                                            <SprintWrapper
                                                                key={slotIndex}
                                                                headerText={`Slot ${slotIndex + 1}`}
                                                                onDelete={() => removeSlot(slotIndex)}
                                                            >
                                                                <Grid2 container spacing={Grid_Gap_LG} size={12}>
                                                                    <Grid2 size={Input_Width_LG}>
                                                                        <Field
                                                                            name={`${prefix}.sessions[${sIndex}].slottime[${slotIndex}].start_time`}
                                                                            component={TimeFormField}
                                                                            label="Start Time"
                                                                        />
                                                                    </Grid2>
                                                                    <Grid2 size={Input_Width_LG}>
                                                                        <Field
                                                                            name={`${prefix}.sessions[${sIndex}].slottime[${slotIndex}].end_time`}
                                                                            component={TimeFormField}
                                                                            label="End Time"
                                                                        />
                                                                    </Grid2>
                                                                </Grid2>
                                                            </SprintWrapper>
                                                        ))}

                                                        <CustomDivider />
                                                        <Grid2 container spacing={Grid_Gap_LG} size={Input_Width}>
                                                            <Button
                                                                startIcon={<AddIcon />}
                                                                onClick={() =>
                                                                    pushSlot({ start_time: '', end_time: '' })
                                                                }
                                                                variant="outlined"
                                                                fullWidth
                                                            >
                                                                Add Slottime
                                                            </Button>
                                                        </Grid2>
                                                    </>
                                                )}
                                            </FieldArray>
                                        </Grid2>
                                    </Grid2>
                                </SprintWrapper>
                            ))}

                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap_LG} size={Input_Width}>
                                <Button
                                    startIcon={<AddIcon />}
                                    onClick={() => pushSession({ day: '', slottime: [] })}
                                    variant="outlined"
                                    fullWidth
                                >
                                    Add Session
                                </Button>
                            </Grid2>
                        </>
                    )}
                </FieldArray>
            </Grid2>
        </Grid2>
    );
};

const RecurringOnlineCourses = ({ onlineType }) => {
    const { token } = useAuthStore()
    const { value, handleChange } = useTabs(0);
    const { showToaster } = useToaster();
    const CourseCategory = [
        { id: 1, value: "category1", label: "category1" },
        { id: 2, value: "category2", label: "category2" }
    ];

    const mutation = useMutation({
        mutationFn: async (formData) => {
            const response = await nodeApi.post("online-courses", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        },
    });

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const formData = new FormData();

        const topLevelFields = [
            "title",
            "category_id",
            "location_id",
            "organizer_id",
            "location_address",
            "short_description",
            "description",
            "learningoutcome",
            "no_of_teachers",
            "no_of_live_class",
            "start_date",
            "end_date",
            "seats",
            "price",

        ];

        // fields that must be numeric
        const numericFields = ["price", "category_id", "location_id"];

        topLevelFields.forEach((field) => {
            const value = values[field];
            if (value !== undefined && value !== null) {
                if (numericFields.includes(field)) {
                    formData.append(field, String(Number(value))); // ✅ force numeric
                } else {
                    formData.append(field, String(value));
                }
            }
        });

        // Append type
        formData.append("type", 6); // string because FormData only accepts string or File
        formData.append("online_type", onlineType);

        // Age range
        if (values.age?.length === 2) {
            formData.append("age_min", String(values.age[0]));
            formData.append("age_max", String(values.age[1]));
        }

        // Cover image
        if (values.cover_image instanceof File) {
            formData.append("cover_image", values.cover_image);
        } else if (values.cover_image) {
            formData.append("cover_image", values.cover_image);
        }
        ["monthlyPackage", "quarterlyPackage", "annualPackage"].forEach(
            (pkgKey, idx) => {
                const pkg = values[pkgKey];
                if (!pkg) return;

                // Upload image separately and replace in JSON with placeholder
                if (pkg.image instanceof File) {
                    formData.append("files", pkg.image);
                    pkg.image = `temp://${idx + 1}`;
                }

                // Convert sessions to schedule
                if (pkg.sessions) {
                    pkg.schedule = pkg.sessions.flatMap((session) =>
                        session.slottime.map((slot) => ({
                            day: session.day,
                            startTime: slot.start_time,
                            endTime: slot.end_time,
                        }))
                    );
                    delete pkg.sessions;
                }

                // Append JSON package
                formData.append(pkgKey, JSON.stringify(pkg));
            }
        );

        mutation.mutate(formData, {
            onSuccess: () => {
                showToaster("success", "Course Added Successfully", "success");
                resetForm();
                setSubmitting(false);
            },
            onError: (err) => {
                console.error("Error submitting course:", err);
                showToaster("error", "Error occurred while submitting course.", "error");
                setSubmitting(false);
            },
        });
    };

    const initialValues = {
        organizer_id:0,
        category_id: 0,
        location_id: 0,
        location_address: "",
        title: "",
        learningoutcome: "",
        short_description: "",
        description: "",
        age: [10, 16],
        price: 0,
        verification_details: "NA",
        cover_image: "",
        start_date: "",
        end_date: "",
        no_of_teachers: "",
        no_of_live_class: "",
        seats: "",
        monthlyPackage: {
            name: '',
            start_date: '',
            end_date: '',
            reduction_price: '',
            levels: [],
            image: null,
            max_slots: '',
            sessions: [],
        },
        quarterlyPackage: {
            name: '',
            start_date: '',
            end_date: '',
            reduction_price: '',
            levels: [],
            image: null,
            max_slots: '',
            sessions: [],
        },
        annualPackage: {
            name: '',
            start_date: '',
            end_date: '',
            reduction_price: '',
            levels: [],
            image: null,
            max_slots: '',
            sessions: [],
        },
    };
    const tabData = [
        { label: 'Monthly Package', prefix: 'monthlyPackage' },
        { label: 'Quarterly Package', prefix: 'quarterlyPackage' },
        { label: 'Yearly Package', prefix: 'annualPackage' },


    ];

    const validationSchema = Yup.object().shape({
        organizer_id: Yup.number().required("Organizer is required"),
        category_id: Yup.number().required("Category is required"),
        location_id: Yup.number().required("Location is required"),
        location_address: Yup.string().required("Location address is required"),
        title: Yup.string().required("Course name is required"),
        learningoutcome: Yup.string().required("Learning outcome is required"),
        short_description: Yup.string().required("Short description is required"),
        description: Yup.string().required("Description is required"),
        age: Yup.array()
            .of(Yup.number().required())
            .min(1)
            .max(20)
            .required("Age range is required"),
        price: Yup.number().required("Price is required"),
        cover_image: Yup.mixed().required("Cover image is required"),
        start_date: Yup.string().required("Start date is required"),
        end_date: Yup.string().required("End date is required"),
        no_of_teachers: Yup.string().required("No of teachers is required"),
        no_of_live_class: Yup.string().required("No of live classes is required"),
        seats: Yup.string().required("Seats are required"),
    });


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ values, resetForm }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap_LG}>

                        <Grid2 children size={12}>
                            <Field
                                name="cover_image"
                                component={DropzoneUploadFormField}
                                label="Image"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="organizer_id"
                                component={IdAutoCompleteField}
                                options={CourseCategory}
                                label="Organizer"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="category_id"
                                component={IdAutoCompleteField}
                                options={CourseCategory}
                                label="Courses Category"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="location_id"
                                component={IdAutoCompleteField}
                                options={CourseCategory}
                                label="Location"
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="location_address"
                                component={TextFormField}
                                label="Location"
                                isRequired
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="title"
                                component={TextFormField}
                                label="Course Name"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="short_description"
                                component={TextFormField}
                                label="Short Description"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="description"
                                component={TextFormField}
                                label="Description"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="learningoutcome"
                                component={TextFormField}
                                label="Learning Outcome"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="no_of_teachers"
                                component={TextFormField}
                                label="No Of teachers"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="no_of_live_class"
                                component={TextFormField}
                                label="No of live Classes"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="start_date"
                                component={DateFormField}
                                label="Start Date"
                                isRequired={true}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="end_date"
                                component={DateFormField}
                                label="End Date"
                                isRequired={true}
                            />
                        </Grid2>
                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="seats"
                                component={TextFormField}
                                label="Seats"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>
                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="age"
                                component={CustomSlider}
                                label="Age"
                                initialValue={0}
                                finalValue={20}
                            />
                        </Grid2>

                        <Grid2 children size={Input_Width_LG}>
                            <Field
                                name="price"
                                component={TextFormField}
                                label="Price"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Typography variant="h4">
                                Add the following details for package separately
                            </Typography>

                            <TabsComponent
                                tabs={tabData.map((t) => ({ label: t.label }))}
                                value={value}
                                onChange={handleChange}
                            />

                            {tabData.map((tab, idx) => (
                                <TabPanel key={idx} value={value} index={idx}>
                                    <RenderPackages prefix={tab.prefix} values={values} />
                                </TabPanel>
                            ))}
                        </Grid2>
                        <CustomDivider size={5} />



                    </Grid2>

                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 size={Input_Width} />
                        <Grid2 size={Input_Width}>
                            <Button fullWidth variant="outlined" onClick={() => resetForm()}>Cancel</Button>
                        </Grid2>
                        <Grid2 size={Input_Width}>
                            <Button fullWidth variant="contained" type="submit">Submit </Button>
                        </Grid2>
                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default RecurringOnlineCourses


